import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	stroke: "#262626",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M18.625 10a8.625 8.625 0 1 1-17.25 0 8.625 8.625 0 0 1 17.25 0ZM5 10h10" })]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20stroke%3D%22%23262626%22%3E%3Cpath%20d%3D%22M18.625%2010a8.625%208.625%200%201%201-17.25%200%208.625%208.625%200%200%201%2017.25%200ZM5%2010h10%22%2F%3E%3C%2Fsvg%3E";
